import { DataGrid } from "@/components/dataGrid";
import { DataForm } from "@/components/dataForm";
import { cache } from "@/utils/common";
import moment from "moment";
// import cloneDeep from "lodash/cloneDeep";
import { BillInfoModal } from "./index.js";
const mixin = {
  components: {
    DataGrid,
    DataForm
  },
  data() {
    return {
      data: [],
      params: { BillType: 1, Status: null },
      columns: [
        {
          title: "序号",
          width: "3%", //宽度
          align: "center", //对齐方式
          type: "indexcolumn" // 类型，indexcolumn = 序号
        },
        {
          title: "单号",
          width: "10%",
          dataIndex: "BillNo",
          customRender: (text, record) => {
            const orderDetail = {
              click: () => {
                this.orderDetail(record);
              }
            };
            return (
              <a-button type="link" {...{ on: orderDetail }}>
                {text}
              </a-button>
            );
          }
        },
        {
          title: "仓库",
          width: "6%",
          dataIndex: "WarehouseName"
        },
        {
          title: "供应商",
          width: "7%",
          dataIndex: "SupplierName"
        },
        {
          title: "状态",
          width: "5%",
          dataIndex: "StatusName"
        },
        {
          title: "收货日期",
          width: "6%",
          dataIndex: "BillDate",
          customRender: text => {
            return moment(text).format("YYYY-MM-DD");
          }
        },
        {
          title: "合计金额",
          align: "right",
          width: "6%",
          dataIndex: "TotalPrice"
        },
        {
          title: "制单人",
          width: "7%",
          dataIndex: "CreatorUserName"
        },
        {
          title: "制单时间",
          width: "8%",
          dataIndex: "CreationTime"
        },
        {
          title: "确认人",
          width: "7%",
          dataIndex: "AuditorName"
        },
        {
          title: "确认时间",
          width: "8%",
          dataIndex: "AuditorDateTime"
        },
        {
          title: "备注",
          dataIndex: "Remark"
        },
        {
          title: "操作",
          dataIndex: "Action",
          width: 200,
          fixed: "right",
          scopedSlots: { customRender: "rowAction" }
        }
      ],
      Status: null,
      searchContent: [],
      searchFormData: {},
      PageIndex: 0,
      PageSize: 10,
      fields: {},
      props: {}
    };
  },
  created() {
    this.AccountDate = cache.get("user").AccountDate;
    this.props = {
      scroll: {
        x: 2000,
        y: window.document.body.clientHeight - 335
      }
    };
    this.searchContent = [
      {
        label: "时间",
        type: "date-range-picker",
        name: "DateRange",
        colnum: 2
      },
      {
        label: "仓库",
        name: "WarehouseId",
        type: "select",
        api: "Common_GetSelect",
        param: {
          Types: "Warehouse"
        },
        dataField: "Data.Warehouse"
      },
      {
        label: "供应商",
        name: "SupplierId",
        type: "select",
        api: "Common_GetSelect",
        param: {
          Types: "Supplier"
        },
        dataField: "Data.Supplier"
      },
      {
        label: "类型",
        name: "BillCategory",
        type: "select",
        valueField: "value",
        textField: "text",
        data: [
          {
            value: 11,
            text: "采购入库"
          },
          {
            value: 12,
            text: "冲账入库"
          }
        ]
      },
      {
        label: "物品",
        name: "GoodsKeyword",
        props: {
          placeholder: "物品名称/代码"
        }
      },
      {
        label: "",
        slot: "search"
      }
    ];
    if (this.type == "instock" || this.type == "outstock") {
      this.columns.splice(2, 0, {
        title: "类型",
        width: "6%",
        dataIndex: "BillCategoryName"
      });
    }
    if (this.type == "outstock") {
      this.columns.splice(4, 1, {
        title: "部门",
        width: "5%",
        dataIndex: "DepartmentName"
      });
      this.searchContent.splice(2, 1, {
        label: "部门",
        name: "DepartmentId",
        type: "select",
        api: "Common_GetSelect",
        param: {
          Types: "Department"
        },
        dataField: "Data.Department"
      });
      this.searchContent[3].data = [
        {
          value: 21,
          text: "领用出库"
        },
        {
          value: 22,
          text: "销售出库"
        }
      ];
    }
    if (this.type == "refund") {
      this.searchContent.splice(3, 1);
    }
    if (this.type == "transfer") {
      this.searchContent.splice(2, 2);
      this.columns.splice(3, 1, {
        title: "调入仓库",
        width: "10%",
        dataIndex: "InWarehouseName"
      });
    }
  },
  // watch: {
  //   fields(oldVal, newVal) {
  //     if(old)
  //   }
  // },
  methods: {
    search(billType /*, type*/) {
      const fields = this.$refs.searchForm.getData();
      this.fields = fields;
      // this.PageIndex =
      //   type == "add" ? 0 : this.$refs.dataGrid.paginationOption.PageIndex;
      let BeginDate = "",
        EndDate = "";
      if (fields.DateRange) {
        if (fields.DateRange[0]) {
          BeginDate = moment(fields.DateRange[0]).format("YYYY-MM-DD");
        }
        if (fields.DateRange[1]) {
          EndDate = moment(fields.DateRange[1]).format("YYYY-MM-DD");
        }
      }
      this.params = {
        BillType: billType,
        Status: this.Status,
        BeginDate: BeginDate,
        EndDate: EndDate,
        WarehouseId: fields.WarehouseId,
        DepartmentId: fields.DepartmentId,
        SupplierId: fields.SupplierId,
        GoodsKeyword: fields.GoodsKeyword,
        BillCategory: fields.BillCategory
      };
      const json = {
        ...this.params,
        PageIndex: 0
      };
      this.$refs.dataGrid.reload(json);
    },
    add(json) {
      BillInfoModal(json);
    },
    tabChange(key) {
      this.Status = key == "" ? null : key;
      this.handleSearch();
    },
    confirm(api, Id) {
      this.$post(api, { Id: Id }).then(() => {
        this.$message.success("操作成功！");
        this.$refs.dataGrid.reload();
      });
    },
    cancel(api, Id) {
      this.$post(api, { Id: Id }).then(() => {
        this.$message.success("取消成功！");
        this.$refs.dataGrid.reload();
      });
    },
    checkDetail(record, api, type) {
      let json = {
        orderId: record.Id,
        title: "编辑",
        api: api,
        type: type,
        actionType: "update",
        update: () => {
          this.$refs.dataGrid.reload();
        }
      };
      if (record.Status !== 0) {
        json.actionType = "check";
        json.title = "查看订单详情";
      }
      BillInfoModal(json);
    }
  }
};
export { mixin };
